import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ProductStates } from '../../../../..';
import { onSearchResultsShown } from '../../../../../../common/analytics';
import { ResultsShownActionSubjectId } from '../../../../../../common/analytics/events';
export var errorAnalyticsGenerator = function errorAnalyticsGenerator(productState, commonAttributes, previousState) {
  if (previousState !== ProductStates.PreQueryLoading && previousState !== ProductStates.PostQueryLoading) {
    return;
  }
  switch (productState) {
    case ProductStates.PreQueryError:
    case ProductStates.PostQueryError:
      return onSearchResultsShown(_objectSpread({
        actionSubjectId: productState === ProductStates.PreQueryError ? ResultsShownActionSubjectId.PREQUERY_ERROR : ResultsShownActionSubjectId.POSTQUERY_ERROR,
        resultCount: 0,
        sectionCount: 0,
        results: []
      }, commonAttributes));
    default:
      break;
  }
};